// src/services/aiConversationService.js
// ============================================================
// مدیریت گفتگوهای AI Chat — Server-backed
// ============================================================

const API_BASE = '/api/db';

/**
 * دریافت همه گفتگوهای یک کاربر از سرور.
 * @param {string} userId
 * @returns {Promise<Array>} آرایه گفتگوها
 */
export async function getConversations(userId) {
  if (!userId) return [];
  try {
    const res = await fetch(
      `${API_BASE}/aiConversations?userId=${encodeURIComponent(userId)}&_sort=updatedAt&_order=desc`
    );
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.warn('⚠️ aiConversationService: getConversations failed', e);
    return [];
  }
}

/**
 * ذخیره یک گفتگو (ایجاد یا به‌روزرسانی).
 * @param {string} userId
 * @param {object} conv — { id, title, messages, createdAt, updatedAt }
 * @returns {Promise<object|null>} رکورد ذخیره‌شده
 */
export async function saveConversation(userId, conv) {
  if (!userId || !conv) return null;
  try {
    const payload = {
      ...conv,
      userId,
      updatedAt: new Date().toISOString(),
    };

    // اگر رکورد قبلی با همان id وجود دارد → PATCH
    const check = await fetch(
      `${API_BASE}/aiConversations?userId=${encodeURIComponent(userId)}&id=${encodeURIComponent(conv.id)}`
    );
    const arr = await check.json();
    const existing = Array.isArray(arr) ? arr[0] : null;

    if (existing) {
      const r = await fetch(`${API_BASE}/aiConversations/${existing.id_server || existing.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...existing, ...payload }),
      });
      return r.ok ? await r.json() : null;
    } else {
      const r = await fetch(`${API_BASE}/aiConversations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      return r.ok ? await r.json() : null;
    }
  } catch (e) {
    console.warn('⚠️ aiConversationService: saveConversation failed', e);
    return null;
  }
}

/**
 * حذف یک گفتگو.
 * @param {string} userId
 * @param {string} convId
 */
export async function deleteConversation(userId, convId) {
  if (!userId || !convId) return false;
  try {
    const res = await fetch(
      `${API_BASE}/aiConversations?userId=${encodeURIComponent(userId)}&id=${encodeURIComponent(convId)}`
    );
    const arr = await res.json();
    if (Array.isArray(arr) && arr.length > 0) {
      await Promise.all(
        arr.map((c) => fetch(`${API_BASE}/aiConversations/${c.id_server || c.id}`, { method: 'DELETE' }).catch(() => {}))
      );
      return true;
    }
    return false;
  } catch (e) {
    console.warn('⚠️ aiConversationService: deleteConversation failed', e);
    return false;
  }
}

/**
 * پاک کردن همه‌ی گفتگوهای یک کاربر.
 */
export async function clearAllConversations(userId) {
  if (!userId) return;
  try {
    const res = await fetch(`${API_BASE}/aiConversations?userId=${encodeURIComponent(userId)}`);
    const arr = await res.json();
    if (Array.isArray(arr)) {
      await Promise.all(
        arr.map((c) => fetch(`${API_BASE}/aiConversations/${c.id_server || c.id}`, { method: 'DELETE' }).catch(() => {}))
      );
    }
  } catch {}
}

export default {
  getConversations,
  saveConversation,
  deleteConversation,
  clearAllConversations,
};